<div class="dialog-container">
  <h2>{{ 'symptoms.noSymptomsDialog.title' | translate }}</h2>
  <mat-dialog-content class="dialog-content">
    {{ 'symptoms.noSymptomsDialog.message' | translate }}
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-action">

    <button mat-button mat-raised-button color="primary" (click)="dialogRef.close(true)">
      {{ 'symptoms.noSymptomsDialog.confirmButton' | translate }}
    </button>

    <button cdkFocusInitial mat-flat-button  (click)="dialogRef.close(false)">
      {{ 'symptoms.noSymptomsDialog.backButton' | translate }}
    </button>

  </mat-dialog-actions>
</div>
